export type PublicRankingVideo = {
  rank: number;
  videoId: string;
  youtubeUrl: string;
  title: string;
  channelId: string | null;
  channelTitle: string | null;
  publishedAt: string | null;
  duration: string | null;
  durationSeconds: number | null;
  durationGroup: "under_3m" | "over_3m";
  thumbnailUrl: string | null;
  viewCount: number | null;
  previousRank: number | null;
  rankChange: number | null;
  previousViewCount: number | null;
  viewCountChange: number | null;
  risingRank: number | null;
  isNewEntry: boolean;
  isRising: boolean;
  weeklyScore: number | null;
  appearanceDays: number | null;
  averageRank: number | null;
  bestRank: number | null;
  weeklyViewCountChange: number | null;
};

export type PublicRankingResponse = {
  countryCode: string;
  categoryId: string;
  categoryTitle: string | null;
  durationGroup: "under_3m" | "over_3m";
  period: "daily" | "weekly";
  capturedForDate: string;
  capturedAt: string | null;
  comparisonDate: string | null;
  periodStartDate: string | null;
  periodEndDate: string | null;
  sourceDayCount: number | null;
  videos: PublicRankingVideo[];
  source: {
    provider: string;
    chart: string;
    rankingMethod: string;
    is24HourViewRanking: boolean;
  };
};

const RANKING_API_URL = (
  process.env.REACT_APP_RANKING_API_URL ??
  "https://youtube-ranking-api-97749727187.asia-northeast3.run.app"
).replace(/\/+$/, "");

export async function getPublicYouTubeRankings(
  countryCode: string,
  categoryId: string,
  durationGroup: "under_3m" | "over_3m",
  period: "daily" | "weekly"
): Promise<PublicRankingResponse> {
  const query = new URLSearchParams({
    countryCode,
    categoryId,
    durationGroup,
    period,
  });
  const response = await fetch(`${RANKING_API_URL}/rankings?${query.toString()}`);
  if (!response.ok) {
    throw new Error(`Ranking API request failed: ${response.status}`);
  }
  return await response.json() as PublicRankingResponse;
}
